import React, { useEffect, useState } from 'react';
import DropDown from '../DropDown';
import { Box, Snackbar, useMediaQuery } from '@mui/material';
import { useQueryParameters } from '../useQueryParameters';
import { useDispatch, useSelector } from 'react-redux';
import { setFileds, setRecipientFields } from '../../../Store/Redux/FileListSlice';
import { fillRecipientsInput } from './Fields/GetFields';
import { toast } from 'react-toastify';

function CkRecipientDropDown({ isPdf, recipients, inputFields, setInputFields, originalFile, setOriginalFile }) {

  const isMobile = useMediaQuery('(max-width:768px)');
  const incrementer = isMobile ? 2 : 3;
  const { getParameter } = useQueryParameters();
  const createmode = getParameter('createmode');
  const [selectedSignRecp, setSelectedSignRecp] = useState([]);
  const [disabled, setDisable] = useState(false);
  const [showmore, setShowmore] = useState(incrementer);
  const dispatch = useDispatch();
  const [templateRecipients, setTemplateRecipientFeilds] = useState([]);
  const { recpInput } = useSelector(state => state.fileList);
  const [recpList, setrecpList] = useState([]);
  const [snackBar, setSnackbar] = useState(false);
  const [snackBarmsg, setSnackbarMsg] = useState('');

  useEffect(() => {
    if (recipients.length > 0) {
      setrecpList(recipients);
    }
  }, [recipients]);

  useEffect(() => {
    if (originalFile) {
      let rfields= [];

      originalFile?.templateConfig?.fields?.map(el => {
        if( el.isrecipient === 'recipient' && rfields.length <  recipients.length){
          el.uuid = recipients[rfields.length].id;
         let re= recpInput.find(r=>r.inputId==el.id && r.inval);
         if(re){
          el.selectedId=[re.inval];
         
         }
           rfields.push(el);
        }
      });
      recpInput
     
      setTemplateRecipientFeilds(rfields)
    }
  }, [originalFile]);

  useEffect(() => {
    if (recpInput.length > 0) {
      setSelectedSignRecp([...recpInput]);
    }
  }, [recpInput]);


  const handleClearRecipientDropdown = (e, inputId, index) => {
    if (isPdf) {
      return;
    }
    const { name, value } = e.target;

    let allData = { ...originalFile };
       const getRecipient = recipients.find(el => el.id === e.target.value);
     console.log({inputId, fields:allData?.templateConfig?.fields})
      console.log({name, value,inputId ,selectedSignRecp})

      const updateRecipient = selectedSignRecp?.map(el =>
        el?.inputId === inputId ? { ...el, name: name, value, inval:"" ,inputId} : el
      );
      setSelectedSignRecp(updateRecipient);
      dispatch(setFileds(updateRecipient));
      templateRecipients.map(t=>{
        if(t.id==inputId){
          t.selectedId=[]
        }
      })
      setTemplateRecipientFeilds(templateRecipients)
      allData?.templateConfig?.fields?.forEach((el) => {
        if (el.id === inputId) {
          el.value = "";
        }
      });
      setOriginalFile(allData);
  }


  const handleRecipientDropdown = (e, inputId, index) => {
    if (isPdf) {
      return;
    }
    const { name, value } = e.target;
    const getRecipient = recipients.find(el => el.id === e.target.value);
    if(!getRecipient){
      return ;
    }

    const Alrady = selectedSignRecp?.length > 0 && selectedSignRecp?.find(el => el?.value && el?.value === value);
    console.log({selectedSignRecp, name, value,inputId})
    if(Alrady){
      toast.error("This Recipient Already selected", {
        position: 'bottom-center',
        toastId: 'custom-tab-content-error-2'
      });
      return 
    }
  

    const checkRecipient = selectedSignRecp?.length > 0 && selectedSignRecp?.find(el => el?.name === name);
    
    if (checkRecipient) {
      const updateRecipient = selectedSignRecp?.map(el =>
        el?.name === name ? { ...el, name: name, value, inval: getRecipient.userData.firstName ,inputId} : el
      );
      setSelectedSignRecp(updateRecipient);
      dispatch(setFileds(updateRecipient));
    } else {
      const newR = [...selectedSignRecp];
      newR[index] = { name, value, inval: getRecipient.userData.firstName ,inputId};
      dispatch(setFileds(newR));
      setSelectedSignRecp(newR);
    }

    templateRecipients.map(t=>{
      if(t.id==inputId){
        t.selectedId=[getRecipient.userData.firstName]
      }
    })
    setTemplateRecipientFeilds(templateRecipients)

    const NewFieldVal = [...inputFields, { ...getRecipient, inputName: name, inputId }];

    let allData = { ...originalFile };
    allData?.templateConfig?.fields?.forEach((el, index) => {
      //console.log("checking receipient", el.placeholder, name, el.placeholder === name, el.placeholder === name && el.isrecipient === "recipient" )
      if (el.placeholder === name && el.isrecipient === "recipient") {
        el.value = getRecipient.userData.firstName;
      }
    });
    setOriginalFile(allData);

    setTimeout(() => {
      setDisable(false);
    }, 600);
  };
  const handleShowmore = () => {
    if (showmore > 10) {
      return;
    }
    const fullVal = isMobile ? 8 : 7;
    setShowmore(preValue => preValue + fullVal);
  };
  const handleShowLess = () => {
    if (showmore < 3) {
      return;
    }

    setShowmore(incrementer);
  };

  return (
    <>
      <Snackbar
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        open={snackBar}
        autoHideDuration={4000}
        onClose={() => setSnackbar(!snackBar)}
        message={snackBarmsg}
      />
      <Box display={'flex'} flexDirection={'column'} rowGap={1}>
        {templateRecipients?.slice(0, showmore).map((item, index) => (
          <DropDown
            key={item.id}
            disabled={disabled}
            width={isMobile ? '95%' : '100%'}
            height={isMobile ? '38px' : '45px'}
            placeholder={item.fieldname}
            name={item.fieldname}
            showClear={true}
            handleChange={e => handleRecipientDropdown(e, item.id, index)}
            dropdownValue={recpList.map(el => ({ ...el.userData, id: el.id, name: el.userData.firstName }))}
            dropDownSelected={[item.selectedId || '']}
            handleClearSelection={e => handleClearRecipientDropdown(e, item.id, index)}
          />
        ))}
        <Box mt={0.5} display={'flex'} columnGap={1}>
          {templateRecipients?.length > incrementer && showmore === incrementer ? (
            <div className='medium5 pointer-css green-color' onClick={() => handleShowmore()}>
              Show more{' '}
            </div>
          ) : (
            ''
          )}
          {showmore === 10 && (
            <div className='medium5 pointer-css green-color' onClick={() => handleShowLess()}>
              Show less{' '}
            </div>
          )}
        </Box>
      </Box>
    </>
  );
}

export default CkRecipientDropDown;
